import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { AccountCertificate } from '@/modules/AccountCertificate/interfaces/account-certificate'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import AccountCertificateDetailDetail from '@/modules/AccountCertificate/views/detail.vue'
import { getAccountCertificate } from '../gql/account-certificate.gql'
import AccountCertificateDialog from './account-certificate-dialog'
import { accountCertificateType } from '../helpers/account-certificate'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    AccountCertificateDetailDetail
  }
})
export default class AccountCertificateDetail extends mixins(AccountCertificateDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Client Information'
    },
    {
      text: 'Accounts',
      to: { name: 'AccountsList' }
    }
  ]

  accountCertificateName = ''

  accountCertificate: AccountCertificate | null = null

  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  tabActive = 0
  tabItems = [
    { title: 'Details', route: 'AccountCertificateDetailDetail' },
    {
      title: 'Document', route: 'AccountCertificateDetailDocument'
    }
  ]

  dateTimeToDisplay = dateTimeToDisplay
  dateToNow = dateToNow
  accountCertificateType = accountCertificateType

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.onResize()
    this.getAccountCertificate()
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async getAccountCertificate () {
    const accountCertificateId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAccountCertificate,
        variables: {
          accountCertificateId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const accountCertificate = result.data.getAccountCertificate as AccountCertificate

      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: accountCertificate.account.name,
          to: {
            name: 'AccountDetailCertificates',
            params: {
              id: accountCertificate.account.id
            }
          }
        })
        this.breadcrumbs.push({
          text: 'Certificate'
        })
        this.breadcrumbs.push({
          text: accountCertificate.name
        })
      }

      this.accountCertificate = accountCertificate
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteAccountCertificateConfirm () {
    if (!this.accountCertificate) {
      return
    }
    await this.deleteAccountCertificatePost()
    this.$router.replace({
      name: 'AccountDetailCertificates',
      params: {
        id: this.accountCertificate.account.id + ''
      }
    })
  }
}
